import { AdminAppState, Page, PagesState, WipState } from '../../state';
import { getPage } from './get-page';
import { getWipPageKey } from '../wip';

export const getWipPage = (state: AdminAppState): Page | null => {
  const key = getWipPageKey(state);
  if (key) {
    return getPage(key)(state as any);
  } else {
    return null;
  }
};
